import { routes } from 'utils/routing';

export const getLoyaltyServiceRewardDetailHref = ({
  loyaltyEngineId,
  rewardId,
}: {
  loyaltyEngineId: string;
  rewardId: string;
}) => ({
  pathname: `${routes.loyaltyRewardsList}/${rewardId}`,
  params: { loyaltyEngineId },
});
